import { createRequestTypes } from '../reduxHelpers';

const ITEM_DATA = createRequestTypes('ITEM_DATA');

export { ITEM_DATA };
